import { Bar, BarConfig } from '@ant-design/plots';

interface CardChartProps {
  completed: number;
  inProgress?: number;
  notStarted: number;
  outdated?: number;
  type?: 'simplified' | 'detailed';
}

function CardChart({
  completed,
  inProgress,
  notStarted,
  outdated,
  type = 'detailed',
}: CardChartProps) {
  const data = [
    {
      label: 'BCP Completed',
      type: 'Completed',
      value: completed,
    },
    {
      label: 'BCP In Progress',
      type: 'In Progress',
      value: inProgress,
    },
    {
      label: 'BCP Not Started',
      type: 'Not Started',
      value: notStarted,
    },
    {
      label: 'BCP Outdated',
      type: 'Outdated',
      value: outdated,
    },
  ];

  const simplifiedData = [
    {
      label: 'BCP Completed',
      type: 'Total',
      value: completed + notStarted,
    },
    {
      label: 'BCP Completed',
      type: 'Completed',
      value: completed,
    },
  ];

  const simplifiedConfig: BarConfig = {
    data: simplifiedData,
    xField: 'value',
    yField: 'label',
    width: 250,
    yAxis: {
      label: null,
    },
    xAxis: false,
    appendPadding: 10,
    color: ['#CDCDCD', '#437EF7'],
    seriesField: 'type',
    barStyle: {
      radius: [30, 30, 0, 0],
    },
    legend: false,
    label: {
      position: 'right',
      offsetX: -6,
      layout: [{ type: 'interval-hide-overlap' }],
      content: (originData) => {
        // Show label only for the first item
        return originData.type === 'Completed' ? originData.value : '';
      },
      style: {
        fill: '#000', // Color of the label text
      },
    },
    barWidthRatio: 0.5,
    height: 50,
  };

  const config: BarConfig = {
    data: type === 'simplified' ? simplifiedData : data,
    xField: 'value',
    yField: 'label',
    width: 280,
    height: 110,
    xAxis: false,
    appendPadding: 30,
    color: ['#7EBA6A', '#3D5A80', '#888888', '#EE6C4D'],
    seriesField: 'type',
    marginRatio: 0,
    limitInPlot: true,
    barStyle: {
      radius: [20, 20, 0, 0],
    },
    legend: false,
    label: {
      position: 'right',
      offsetX: 4,
      layout: [{ type: 'interval-hide-overlap' }, { type: 'adjust-color' }],
    },
  };

  const actualConfig = type === 'simplified' ? simplifiedConfig : config;

  return <Bar {...actualConfig} />;
}

export default CardChart;
